import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { DPage } from '../structure';

/**
 * Loading placeholder for a page or a dialog body. Instead of a full-page
 * spinner (which hides the layout and feels slower than it is), this reserves
 * the rough shape of what's coming: a heading, a toolbar-ish row, and a stack of
 * full-width bars that read equally as table rows or form fields. It's used in
 * both contexts, so it's deliberately content-agnostic.
 */
export function DPageLoader() {
    return (
        <DPage>
            <Box
                sx={{
                    p: 2,
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Skeleton variant={'text'} width={240} height={36} />
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <Skeleton variant={'rounded'} width={220} height={40} />
                    <Skeleton variant={'rounded'} width={160} height={40} />
                    <Skeleton variant={'rounded'} width={120} height={40} />
                </Box>
                {Array.from({ length: 6 }).map((_, index) => (
                    <Skeleton key={index} variant={'rounded'} height={44} />
                ))}
            </Box>
        </DPage>
    );
}
